module.exports = __webpack_public_path__ + "img/notAuth.c4954a1c.svg";